import { ModuleModel } from '../../module.model.interface';
import { DataEntryDescriptor } from '../../dataentry/model/dataentry';
import { FormDescriptor } from '../../form/model/form';
import { ApiProfileDescriptor } from '../../profile/model/api.profile';
import { OrganizationModel } from '../../organization/model/organization.model';

export enum ModificationRequestState {
  Sent,
  Approved,
  Rejected
}

export class ModificationRequestStateDetail implements ModuleModel {
  public discriminator = 'ModificationRequestStateDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const ModificationRequestStateMap = {
  Sent: new ModificationRequestStateDetail({ id: 'Sent', name: 'Elküldve' }),
  Approved: new ModificationRequestStateDetail({ id: 'Approved', name: 'Elfogadva' }),
  Rejected: new ModificationRequestStateDetail({ id: 'Rejected', name: 'Visszautasítva' }),
};

export const ModificationRequestStateList: ModificationRequestStateDetail[] = [
  ModificationRequestStateMap.Sent,
  ModificationRequestStateMap.Approved,
  ModificationRequestStateMap.Rejected,
];

export class ModificationRequestDescriptor implements ModuleModel {
  public discriminator = 'ModificationRequestDescriptor';

  public id: string;
  public dataEntryId: string;
  public organizationId: string;
  public formId: string;
  public submittedBy: string;
  public submittedOn: Date;
  public modificationRequestState: ModificationRequestState;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public dataEntryDetail: DataEntryDescriptor;
  public dataEntryReference: string;
  public dataEntryVersion?: number;
  public dataEntryPeriodStart?: Date;

  public organizationDetail: OrganizationModel;
  public organizationMekhCode?: string;
  public organizationName?: string;
  public organizationTitleToDisplay?: string;

  public formDetail: FormDescriptor;
  public formIdentifier?: string;
  public formVersion?: number;
  public formTitle?: string;
  public formTitleToDisplay?: string;

  public dataEntryClerkDetail: ApiProfileDescriptor;
  public dataEntryClerkFullName?: string;

  public submittedByDetail: ApiProfileDescriptor;
  public submittedByFullName?: string;

  constructor(options?: {
    id: string;
    dataEntryId: string;
    organizationId: string;
    formId: string;
    submittedBy: string;
    submittedOn: Date;
    modificationRequestState: ModificationRequestState;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.dataEntryId = options.dataEntryId;
      this.organizationId = options.organizationId;
      this.formId = options.formId;
      this.submittedBy = options.submittedBy;
      this.submittedOn = options.submittedOn;
      this.modificationRequestState = options.modificationRequestState;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}

export enum ModificationRequestMachineAttributeName {
  Request,
  Response
}

export class ModificationRequestMachineAttribute {
public name: ModificationRequestMachineAttributeName;
public value: string;
public optional: boolean;
public object: ModificationRequestDescriptor;

constructor(options?: {
  name: ModificationRequestMachineAttributeName;
  value: string;
  optional: boolean;
  object: ModificationRequestDescriptor;
}) {

  if (options) {
    this.name = options.name;
    this.value = options.value;
    this.optional = options.optional;
    this.object = options.object;
  }
}
}

export enum ModificationRequestMachineCommand {
  Create,
  Approve,
  Reject
}

export const ModificationRequestMachineCommandMessage = {
  Create : { done: 'A módosítási kérelem elküldése sikeresen megtörtént.', fail: 'A módosítási kérelem elküldése nem sikerült.' },
  Approve : { done: 'A módosítási kérelem jóváhagyása sikeresen megtörtént.', fail: 'A módosítási kérelem jóváhagyása nem sikerült.' },
  Reject : { done: 'A módosítási kérelem elutasítása sikeresen megtörtént.', fail: 'A módosítási kérelem elutasítása nem sikerült.' },
};

export class ModificationRequestMachineStateDescriptor implements ModuleModel {
public discriminator = 'ModificationRequestMachineStateDescriptor';

public command?: ModificationRequestMachineCommand;
public attributes?: ModificationRequestMachineAttribute[];

constructor(options?: {
  command?: ModificationRequestMachineCommand;
  attributes?: ModificationRequestMachineAttribute[];
  }) {

  if (options) {
    this.command = options.command;
    this.attributes = options.attributes;
  }
}
}



// WEBPACK FOOTER //
// ./src/app/modules/modification.request/model/modification.request.ts